<template>
  <el-select
    class="load-more-select"
    :value="isInit ? defaultVal : value"
    v-loadmore="loadMore"
    @focus="focus"
    @clear="clear"
    filterable
    remote
    :filter-method="handleSearch"
    :loading="loading"
    :multiple="isMultiple"
    clearable
    v-bind="$attrs"
    v-on="$listeners"
    @change="changeValue"
    :placeholder="placeholder"
    :allow-create="isAllowCreate"
    :popper-append-to-body="appendToBody"
  >
    <el-option
      v-for="(option, i) in data"
      :label="
        !dictLabelAppend
          ? option[dictLabel]
          : `${option[dictLabel]}(${option[dictLabelAppend]})`
      "
      :value="option[dictValue]"
      :disabled="option[dictDisabled]"
      :key="option[dictValue] + i"
    ></el-option>
    <el-option v-if="hasMore" disabled label="加载中..." value="-1"></el-option>
    <el-option
      v-if="data.length == 0"
      disabled
      label="暂无数据"
      value="-1"
    ></el-option>
  </el-select>
</template>

<script>
export default {
  props: {
    value: {
      default: "",
    },
    // 列表数据
    data: {
      type: Array,
      default: () => [],
    },
    dictLabel: {
      type: String,
      default: "label",
    },
    dictValue: {
      type: String,
      default: "value",
    },
    dictDisabled: {
      type: String,
      default: "disabled",
    },
    isMultiple: {
      type: Boolean,
      default: false,
    },
    // 调用页数的接口
    request: {
      type: Function,
      default: () => {},
    },
    // 传入的页码
    page: {
      type: [Number, String],
      default: 1,
    },
    // 是否还有更多数据
    hasMore: {
      type: Boolean,
      default: true,
    },
    appendToBody: {
      type: Boolean,
      default: true,
    },
    placeholder: {
      type: String,
      default: () => "请选择",
    },
    defaultVal: {
      type: String,
      default: () => "",
    },
    isInit: {
      type: Boolean,
      default: () => false,
    },
    dictLabelAppend: {
      type: String,
      default: "",
    },
    isAllowCreate: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      keyword: "", // 存储关键字用
      loading: false,
    };
  },
  methods: {
    // 请求下一页的数据
    loadMore() {
      // 如果没有更多数据，则不请求
      if (!this.hasMore) {
        return;
      }
      // 如果intercept属性为true则不请求数据，
      if (this.loadMore.intercept) {
        return;
      }
      this.loadMore.intercept = true;
      this.request({
        page: this.page + 1,
        more: true,
        keyword: this.keyword,
      }).then(() => {
        this.loadMore.intercept = false;
      });
    },
    changeValue(val) {
      this.$emit("ChangeValue", val);
    },
    // 选中下拉框没有数据时，自动请求第一页的数据
    focus() {
      if (!this.data.length) {
        this.request({ page: 1 });
      }
    },
    handleSearch(keyword) {
      this.keyword = keyword;
      this.loading = true;
      // console.log(keyword);
      this.request({ page: 1, keyword: keyword }).then(() => {
        this.loading = false;
      });
    },
    // 删除选中时，如果请求了关键字，则清除关键字再请求第一页的数据
    clear() {
      if (this.keyword) {
        this.keyword = "";
        this.request({ page: 1 });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.load-more-select {}
</style>
